import React from 'react';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import PropTypes from 'prop-types';
import { Text } from '@uhg-abyss/web/ui/Text';
import { styled } from '@uhg-abyss/web/tools/styled';
import { MediaQuery } from '@uhg-abyss/web/ui/MediaQuery';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import { Layout } from '@uhg-abyss/web/ui/Layout';

const StyledHeading = styled(Layout.Group, {
  paddingLeft: '10px',
  textAlign: 'left',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '20px',
  boxSizing: 'border-box',
  '@media (max-width: 900px)': {
    paddingLeft: '0px',
  },
});

const CustomFlex = styled('div', {
  static: {
    display: 'flex',
    boxSizing: 'border-box',
  },
  dynamic: ({ alignContent, alignItems, direction, justify }) => ({
    alignContent,
    alignItems,
    flexDirection: direction,
    justifyContent: justify,
  }),
});

export const CustomTabLabel = ({
  iconName,
  label,
  subText,
  hasLabelCount,
  labelCount,
}) => {
  return (
    <CustomFlex alignItems='center'>
      <MediaQuery largerThan={1079}>
        <IconBrand icon={iconName} size='20px' brand='uhc' />
      </MediaQuery>
      <CustomFlex direction='column'>
        <StyledHeading>
          {label}
          <If condition={hasLabelCount}>
            <Badge rounded outline variant='warning'>
              {labelCount}
            </Badge>
          </If>
        </StyledHeading>
        <Text
          size='12px'
          color='$gray7'
          style={{
            textAlign: 'left',
            fontWeight: 'normal',
            marginTop: subText ? '10px' : '0px',
          }}
          css={{
            'abyss-text-root': {
              paddingLeft: '10px',
              '@media (max-width: 900px)': {
                paddingLeft: '0px',
              },
            },
          }}
        >
          {subText}
        </Text>
      </CustomFlex>
    </CustomFlex>
  );
};

CustomTabLabel.propTypes = {
  iconName: PropTypes.string,
  label: PropTypes.string,
  subText: PropTypes.string,
  labelCount: PropTypes.number,
  hasLabelCount: PropTypes.bool,
};

CustomTabLabel.defaultProps = {
  iconName: '',
  label: '',
  subText: '',
  labelCount: 0,
  hasLabelCount: false,
};
